import NextImage from 'next/image';

import IconLink from '~/components/IconLink';
import { SteamGameInterface } from '~/payload-types';

type Props = SteamGameInterface & {};

export const SteamGameBlock = (props: Props) => {
  return (
    <div className="flex flex-col items-center">
      <span>Available on Steam</span>

      <IconLink className="border-b-0" block href={props.url}>
        <NextImage
          src="/steam-logo.png"
          alt="Steam Logo"
          className="w-72"
          width={1920}
          height={1080}
        />
      </IconLink>
    </div>
  );
};
